import { render } from "./audio-v1.vue?vue&type=template&id=3b9b644c&scoped=true"
import script from "./audio-v1.vue?vue&type=script&lang=js"
export * from "./audio-v1.vue?vue&type=script&lang=js"

import "./audio-v1.vue?vue&type=style&index=0&id=3b9b644c&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9b644c"]])

export default __exports__